
import TableList from "@components/templates/tablelist";
import { HttpGetActivityProcessList,HttpGetActivityProcessnReport,HttpGetEditStatusByUser} from "@/service/products/activityProcess";
import { mapGetters } from "vuex";
import comIndex from './update'
import {Button, Dropdown, DropdownItem, DropdownMenu, Icon} from "view-design";
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    EQ_status: null,
                    EQ_cancelStatus:null,
                    EQ_activityType:null,
                }
            },
            listData:{
                sum:0,
                submit:0,
                success:0,
                reject: 0,
                cancellation:0,
                cancelSuccess: 0,
                cancelReject:0,
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            datename:'',
            datetime:'',
            Plugins: {show: true},
            initData:'',
            TreeSearchs:{
                show:true,
                data: [
                    {
                        label: "促销类型",
                        children: [
                            {
                                label: "LD",
                                key: "EQ_activityType",
                                value: 3
                            },
                            {
                                label: "Best Deal",
                                key:'EQ_activityType',
                                value: 2
                            }, 
                            {
                                label: "Price Discount",
                                key:'EQ_activityType',
                                value: 1
                            }, 
                            {
                                label: "Coupon",
                                key:'EQ_activityType',
                                value: 0
                            }, 
                            {
                                label: "全部",
                                key:'EQ_activityType',
                                value: 5
                            }
                        ]
                    }

                ]
            },
        };
    },

    created() {
        this.update();
    },

    methods: {
        ajaxRequest: HttpGetActivityProcessList,
        interceptRequest: (params) => {
            if (params.search.EQ_activityType == "5"||params.search.EQ_activityType == 5) {
                params.search.EQ_activityType=null
            }
            if (params.search.EQ_status == "9"||params.search.EQ_status == 9) {
                params.search.EQ_status = null
                params.search.EQ_activityType = null
            }
            if (params.search.EQ_status == "0" || params.search.EQ_status == 0) {
                params.search.EQ_cancelStatus = 0
            } else if (params.search.EQ_status == "1" || params.search.EQ_status == 1) {
                params.search.EQ_cancelStatus = 0
            } else if (params.search.EQ_status == "2" || params.search.EQ_status == 2) {
                params.search.EQ_cancelStatus = 0
            }
            const {CN_asin } = params.search;
            let IN_asin;
            if(CN_asin){
                IN_asin = CN_asin.replace(/\n/g,",");
            }
            params.search.IN_asin = IN_asin;

            delete params.search.CN_asin;
            return {
                ...params
            }
        },
        interceptResponse(){
            this.update();
        },
        update(){
            this.loading=true
            const formdata = { ...this.formData, search: { ...this.formData.search } };
            if (formdata.search.EQ_activityType == "5"||formdata.search.EQ_activityType == 5) {
                formdata.search.EQ_activityType=null
            }
            formdata.search.EQ_status = "";
            formdata.search.EQ_cancelStatus = "";
            HttpGetActivityProcessnReport(formdata).then(res=>{
                for(var item in res.data){
                    if(res.data.hasOwnProperty(item)){
                        if(item == '总计'){
                            this.listData.sum = res.data[item]
                        }
                        if(item == '待提报'){
                            this.listData.submit = res.data[item]
                        }
                        if(item == '提报成功'){
                            this.listData.success = res.data[item]
                        }
                        if(item == '提报失败'){
                            this.listData.reject = res.data[item]
                        }
                        if(item == '取消中'){
                            this.listData.cancellation = res.data[item]
                        }
                        if(item == '已取消'){
                            this.listData.cancelSuccess = res.data[item]
                        }
                        if(item == '取消失败'){
                            this.listData.cancelReject = res.data[item]
                        }
                    }
                }
                this.loading=false
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        handleOperates(params, type,batch) {
            if(batch===true){
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'activityProcessUpdate',
                        params: { type: "add"},
                        query: { sourceType: this.formData.search.EQ_activityType}
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'activityProcessUpdate',
                        params: { type: "edit"},
                        query: { id: params.id , sourceType: params.activityType },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:{id:params.id,type:"customer"},
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "cancel":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params.id,status:params.status,cancelStatus:2,batchCancel:0},
                        title: "取消操作",
                        ajaxRequest:HttpGetEditStatusByUser
                    }
                    break;
                case "cancellation":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params.id,status:params.status,cancelStatus:1,batchCancel:0},
                        title: "取消操作",
                        ajaxRequest:HttpGetEditStatusByUser
                    }
                    break;
                case "submit":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params.id,status:0,cancelStatus:0,batchCancel:0},
                        title: "提交操作",
                        ajaxRequest:HttpGetEditStatusByUser
                    }
                    break;
                case "batchCancel":
                    this.operate={
                        show: true,
                        alert: "primary",
                        params:{ids:params,status:0,cancelStatus:0,batchCancel:1},
                        title: "批量取消操作",
                        ajaxRequest:HttpGetEditStatusByUser
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: "批量导入",
                        showFooter: false,
                        width:460,
                        data: {
                            contextId: global.SYSID,
                            activityType:this.formData.search.EQ_activityType
                        },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/activityProcessManagement/importExcel",
                        name: "excelFile",
                        download:()=>{
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS +'/api/v2/activityProcessManagement/importTemplate',{activityType:this.formData.search.EQ_activityType},'download')
                        },
                        component: "compUpload",
                    };
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show: true,
                params:id,
                operate:'edit'
            }, ]
        },
    },
    computed: {
        ...mapGetters('diction', ['getNewProductList', 'getNewAccountIdList']),
        ...mapGetters('dictionary', ['getOrgList']),

        TabsData(){
            // console.log(this.listData)
            return [
                {
                    label: `全部（${this.listData.sum}）`,
                    key:'EQ_status',
                    val: 9
                },
                {
                    label: `待提报（${this.listData.submit}）`,
                    key:'EQ_status',
                    val: 0
                }, {
                    label: `提报成功（${this.listData.success}）`,
                    key: "EQ_status",
                    val: 1
                }, {
                    label: `提报失败（${this.listData.reject}）`,
                    key: "EQ_status",
                    val: 2
                },{
                    label: `取消中（${this.listData.cancellation}）`,
                    key:'EQ_cancelStatus',
                    val: 1
                },{
                    label: `已取消（${this.listData.cancelSuccess}）`,
                    key:'EQ_cancelStatus',
                    val: 2
                },
                {
                    label: `取消失败（${this.listData.cancelReject}）`,
                    key:'EQ_cancelStatus',
                    val: 3
                },
            ]
        },
        ToolsData() {
            if(this.handleAuth('product.activityProcess.set')&&this.formData.search.EQ_activityType != 5&&this.formData.search.EQ_activityType != null){
                return [
                    {
                        name: "添加",
                        operate: "add",
                        theme: "primary",
                    },
                    {
                        name: "批量取消",
                        operate: "batchCancel",
                        batch: true,
                        more:true
                    },
                    {
                        name: "批量导入",
                        operate: "import",
                        more:true
                    },
                ]
            }
        },
        SearchsData() {
            const dropStyle="width:auto;";
            return  [
                {
                    label: "活动名称",
                    tag: 'vInput',
                    key: 'EQ_promotionName',
                    show:true,
                },
                {
                    label: "店铺",
                    tag: 'vSelect',
                    key: 'EQ_channelId',
                    show:true,
                    options:this.getNewAccountIdList,
                    props:{
                        dropStyle,
                        filterable:true,
                    }
                },
                
                // 隐藏起来的搜索
                {
                    label: "ASIN",
                    tag: 'vTextarea',
                    key: 'CN_asin',
                    style: "width:200px",
                    props:{
                        placeholder:"支持输入多个，一行一个ASIN",
                    },
                },
                {
                    label: "活动类型",
                    tag: 'vSelect',
                    key: 'EQ_movementType',
                    hidden:!(this.formData.search['all']==null),
                    options:[
                        {label:'普通活动',value:0},
                        {label: 'Prime Day', value: 1 },
                        {label: 'Prime Big Deal Days', value: 2 },
                        {label:'Black Friday/Cyber Monday',value:3}
                    ]
                },
                {
                    label: '活动开始时间',
                    tag: 'vDatepicker',
                    key: 'BT_beginTime',
                    style: "width:200px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: '活动结束时间',
                    tag: 'vDatepicker',
                    key: 'BT_endTime',
                    style: "width:200px",
                    hidden:!(this.formData.search['all']==null),
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                // {
                //     label: "创建人",
                //     tag: 'vInput',
                //     key: 'EQ_createdName',
                //     hidden:!(this.formData.search['all']==null),
                // },
                // {
                //     label: "编辑人",
                //     tag: 'vInput',
                //     key: 'EQ_updatedName',
                //     hidden:!(this.formData.search['all']==null),
                // },
                // {
                //     label: "备注",
                //     tag: 'vInput',
                //     key: 'CN_remark',
                //     hidden:!(this.formData.search['all']==null),
                // },
                {
                    label: '创建时间',
                    key: 'BT_createdAt',
                    tag: 'vDatepicker',
                    style: "width:280px",
                    props: {
                        placeholder: "Select date",
                        format: 'yyyy-mm-dd 00:00:00 ~ yyyy-mm-dd 23:59:59',
                        confirm: false,
                    }
                },
            ]
        },
        columns() {
            return  [
                {
                    show:false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },{
                    title: '操作',
                    width: 70,
                    render: (h, { row }) => {
                        if(this.formData.search.EQ_activityType != 5){
                            if(row.status == 0 && row.cancelStatus==0){
                                return <Dropdown placement="bottom-start" trigger="click">
                                    <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                <DropdownMenu slot="list" class="text-left">
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'cancel')}>取消</DropdownItem>
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'edit')}>编辑</DropdownItem>
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'query')}>查看</DropdownItem>
                                    </DropdownMenu>
                                    </Dropdown >
                            }else if (row.status == 2 && row.cancelStatus==0) {
                                return <Dropdown placement="bottom-start" trigger="click">
                                    <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                    <DropdownMenu slot="list" class="text-left">
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'submit')}>提交</DropdownItem>
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'cancel')}>取消</DropdownItem>
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'edit')}>编辑</DropdownItem>
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'query')}>查看</DropdownItem>
                                    </DropdownMenu>
                                    </Dropdown >
                            }else if (row.status == 1 && row.cancelStatus==0) {
                                return <Dropdown placement="bottom-start" trigger="click">
                                    <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                    <DropdownMenu slot="list" class="text-left">
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'cancellation')}>取消</DropdownItem>
                                        <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'query')}>查看</DropdownItem>
                                    </DropdownMenu>
                                    </Dropdown >
                            }else {
                                return <Dropdown placement="bottom-start" trigger="click">
                                <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                                <DropdownMenu slot="list" class="text-left">
                                <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'query')}>查看</DropdownItem>
                                </DropdownMenu>
                                </Dropdown >
                            }
                        }else {
                            return <Dropdown placement="bottom-start" trigger="click">
                            <Button size='small' type='info'>操作 &nbsp;<Icon type="md-arrow-dropdown" /></Button>
                            <DropdownMenu slot="list" class="text-left">
                            <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, row, 'query')}>查看</DropdownItem>
                            </DropdownMenu>
                            </Dropdown >
                        }
                    }
                },
                {
                    title: '促销类型',
                    width: 220,
                    render:(h, { row })=>{
                        const activityType = row.activityType;
                        let activityTypeName = ''
                        if(activityType == 0){
                            activityTypeName = "Coupon"
                        }
                        if(activityType == 1){
                            activityTypeName = "Price Discount"
                        }
                        if(activityType == 2){
                            activityTypeName = "Best Deal"
                        }
                        if(activityType == 3){
                            activityTypeName = "LD"
                        }
                        if (row.movementType != 0) {
                            return <div>{activityTypeName}<span style="margin-left: 5px;" >(</span><span style="color: red;">{row.movementTypeName}</span><span>)</span></div>   
                        }  else {
                            return <div>{activityTypeName}</div>
                        }
                    }
                },
                {
                    title: '状态',
                    width: 140,
                    render:(h, { row })=>{
                        const status = row.status;
                        const cancelStatus = row.cancelStatus;
                        let statusName = ''
                        let cancelStatusName = ''
                        if(status == 0){
                            statusName = "待提报";
                        }
                        if(status == 1){
                            statusName = "提报成功";
                        }
                        if(status == 2){
                            statusName = "提报失败";
                        }
                        if(cancelStatus == 1){
                            cancelStatusName = "取消中";
                        }
                        if(cancelStatus == 2){
                            cancelStatusName = "已取消";
                        }
                        if(cancelStatus == 3){
                            cancelStatusName = "取消失败";
                        }
                        if (cancelStatusName != '') {
                            return <div>{statusName}<span style="margin-left: 5px;" >(</span><span style="color: red;">{cancelStatusName}</span><span>)</span></div>
                        } else {
                            return <div>{statusName}</div>
                        }
                        
                    }
                },
                {
                    title: 'ASIN/店铺',
                    render: (h, { row }) => {
                        return <div>
                            <div>ASIN：{row.asin || '--'}</div>
                            <div>店铺：{row.channelFlag || '--'}</div>
                        </div>
                    },
                },
                {
                    title: 'Coupon信息',
                    render: (h, { row }) => {
                        return <div>
                        <div>活动名称：{row.promotionName || '--'}</div>
                        <div>优惠券名称：{row.couponName || '--'}</div>
                        <div>优惠预算:{row.discountedBudget || '--'}</div>
                        </div>
                    },
                },
                {
                    title: '开始时间/结束时间',
                    render: (h, { row }) => {
                        if (row.beginTime == null && row.endTime == null) {
                            return <div>--</div>
                        } else {
                            return <div>
                        <span>{row.beginTime || '--'}</span>~<span>{row.endTime || '--'}</span>
                        </div> 
                        }
                    },
                },
                {
                    title: '折扣/金额/数量',
                    render: (h, { row }) => {
                        return <div>
                        <div>折扣形式：{row.discountType == 0 ? "百分比":"固定金额" || '--'}</div>
                        <div>金额/百分比：{row.unitAmount || '--'}</div>
                        <div>数量：{row.quantity || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '折扣前后价格',
                    render: (h, { row }) => {
                        return <div>
                        <div>折扣前：{row.priceBeforeDiscount || '--'}</div>
                        <div>折扣后：{row.priceAfterDiscount || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '实际折扣价格',
                    render: (h, { row }) => {
                        return <div>
                        <div>实际折扣金额：{row.actualDiscountAmount || '--'}</div>
                        <div>实际折扣后价格：{row.actualDiscountedPrice || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '创建人/创建时间',
                    render: (h, { row }) => {
                        return <div>
                        <div>{row.createdName || '--'}</div>
                        <div>{row.createdAt || '--'}</div>
                        </div>

                    },
                }
            ];
        },

    },

};
